module.exports = __webpack_public_path__ + "static/media/logo_mtp.64c6ce91.jpg";